import http from '../http-common';

const API_URL_PATH = 'avatar-interviews/';
const API_URL_PATH_UTILS = 'utils/';

class AvatarInterviewService {
  getDynamicSteps(id) {
    return http.get(API_URL_PATH + id);
  }

  completeStep(id, step, body) {
    return http.post(API_URL_PATH + `${id}/steps/${step - 1}`, body);
  }

  getInterviewSteps(id, interviewId, step, question) {
    return http.get(
      API_URL_PATH + `${id}/steps/${step}?interviewId=${interviewId}&questionNumber=${question}`
    );
  }

  sendFeedback(opinion, comment, candidateId, interviewId, interviewTypeId) {
    const data = {
      feedback: opinion.toUpperCase(),
      comment: comment,
      candidateId: candidateId,
      interviewId: interviewId,
      interviewTypeId: interviewTypeId,
    };
    return http.post(API_URL_PATH + `${interviewId}/feedback`, data);
  }

  getLikertOptions() {
    return http.get(API_URL_PATH_UTILS + '/likert-test-options');
  }
}

export default new AvatarInterviewService();
